import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TestimoniosHero from './components/TestimoniosHero';
import StatsSection from './components/StatsSection';
import AltaCosturaTestimonials from './components/AltaCosturaTestimonials';
import ArreglosTestimonials from './components/ArreglosTestimonials';
import TestimoniosCTA from './components/TestimoniosCTA';
import { useSEO } from '../../hooks/useSEO';
import { SchemaMarkup } from '../../components/SEOHead';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Inicio',
      item: 'https://anthonysanchezc.com',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Testimonios',
      item: 'https://anthonysanchezc.com/testimonios',
    },
  ],
};

export default function Testimonios() {
  useSEO({
    title: 'Testimonios | Clientes Alta Costura & Arreglos | Anthony Sánchez Couture',
    description: 'Descubre lo que dicen nuestros clientes de alta costura y arreglos en Barcelona. Experiencias reales de vestidos de gala, novia y confección a medida.',
    keywords: 'testimonios alta costura Barcelona, opiniones vestidos gala, reseñas arreglos ropa, clientes Anthony Sánchez, atelier Barcelona',
    canonical: '/testimonios',
    ogTitle: 'Testimonios — Experiencias de Nuestros Clientes',
    ogDescription: 'Opiniones reales de clientes de alta costura y arreglos en Barcelona. Descubre sus experiencias con Anthony Sánchez Couture.',
    ogType: 'website',
  });

  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={breadcrumbSchema} />
      <Navbar />
      <main>
        <TestimoniosHero />
        <StatsSection />
        <AltaCosturaTestimonials />
        <ArreglosTestimonials />
        <TestimoniosCTA />
      </main>
      <Footer />
    </div>
  );
}